<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <el-col :span="2" :xs="12">
          <el-form-item prop="online">
            <el-select v-model="params.state" placeholder="状态">
              <el-option
                v-for="item in status"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5" :xs="12">
          <el-form-item prop="cardId">
            <el-input
              v-model="params.cardId"
              maxlength="8"
              placeholder="输入卡片编号查询"
            />
          </el-form-item>
        </el-col>
        <el-col :span="5" :xs="12">
          <el-form-item prop="phone">
            <el-input v-model="params.phone" placeholder="输入手机号码查询" />
          </el-form-item>
        </el-col>
        <el-col :span="5" :xs="12">
          <el-form-item prop="name">
            <el-input v-model="params.name" placeholder="输入姓名查询" />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-row class="xs-m-p">
      <el-button plain type="success" @click="setCardList"
        >批量设置电卡</el-button
      >
    </el-row>
    <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @selection-change="handleSelectionChange"
      @sort-change="sort_change"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column fixed label="卡片编号" prop="cardId">
        <template #default="scope">
          <div class="click" @click="skip(scope.row.cardId, scope.row.id)">
            {{ scope.row.cardId }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="手机号码" prop="phone">
        <template #default="scope">
          {{
            !scope.row.phone || scope.row.phone == "0"
              ? "未绑定"
              : scope.row.phone
          }}
        </template>
      </el-table-column>
      <el-table-column label="用户编号" prop="memberId" />
      <el-table-column label="用户类型" prop="memberType" width="100">
        <template slot-scope="scope">
          {{
            scope.row.memberType == "1"
              ? "微信"
              : scope.row.memberType == "7"
              ? "支付宝"
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column label="用户姓名" prop="name">
        <template #default="scope">
          {{ scope.row.name === "0" ? "未绑定用户" : scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="余额" prop="money" />
      <el-table-column label="豆币" prop="token" />
      <el-table-column label="累计充值" prop="grandTotalMoney" />
      <el-table-column label="状态">
        <template #default="scope">
          <template v-if="scope.row.state === '0'"> 未绑定 </template>
          <template v-if="scope.row.state === '1'"> 已绑定 </template>
          <template v-if="scope.row.state === '-1'"> 已禁用 </template>
          <template v-if="scope.row.state === '-2'"> 已挂失 </template>
          <template v-if="scope.row.state === '-3'"> 已更换 </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="340">
        <template #default="scope">
          <template v-if="scope.row.state === '-1'">
            <el-button size="mini" @click="activate(scope.row.id)"
              >激活</el-button
            >
          </template>
          <template v-else-if="scope.row.state === '0'">
            <el-button size="mini" @click="bind(scope.row.id)">绑定</el-button>
          </template>
          <template v-else-if="scope.row.state === '-2'">
            <el-button size="mini" @click="noLoss(scope.row.id)"
              >取消挂失</el-button
            >
          </template>
          <template v-else-if="scope.row.state === '1'">
            <el-button size="mini" @click="shift(scope.row.id)">转移</el-button>
            <el-button size="mini" @click="pay(scope)">充值</el-button>
            <el-button size="mini" @click="loss(scope.row.id)">挂失</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="
                () => {
                  deleteId = scope.row.id;
                  unbindDialog = true;
                }
              "
            >
              解绑
            </el-button>
            <el-button size="mini" type="danger" @click="disabled(scope.row.id)"
              >禁用</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total" />
    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="bindDialog"
      title="绑定"
    >
      <el-form
        ref="bindForm"
        :model="bindForm"
        :rules="bindRules"
        label-width="auto"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="bindForm.name" placeholder="姓名" />
        </el-form-item>
        <!-- <el-form-item label="电话" prop="phone">
          <el-input
            v-model.number="bindForm.phone"
            maxlength="11"
            placeholder="电话"
          />
        </el-form-item> -->
      </el-form>
      <div slot="footer">
        <el-button @click="bindDialog = false">取 消</el-button>
        <el-button type="primary" @click="binding">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="shiftDialog"
      title="转移"
    >
      <el-form
        ref="shiftForm"
        :model="shiftForm"
        :rules="shiftRules"
        label-width="auto"
      >
        <el-form-item label="转移编号" prop="newCardNum">
          <el-input v-model="shiftForm.newCardNum" placeholder="转移编号" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="shiftDialog = false">取消</el-button>
        <el-button type="primary" @click="shifting">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="unbindDialog"
      title="解绑"
    >
      <div style="text-align: center; font-size: 30px">
        <i class="el-icon-warning" />
        <span style="text-align: center">确定解绑该卡片</span>
      </div>
      <div slot="footer">
        <el-button @click="unbindDialog = false">取消</el-button>
        <el-button type="primary" @click="unbind">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="addMoney"
      title="用户充值"
    >
      <el-form
        ref="payForm"
        :model="addMoneyForm"
        :rules="moneyRules"
        label-width="auto"
      >
        <el-form-item label="用户编号">
          {{ addMoneyForm.userId }}
        </el-form-item>
        <el-form-item label="用户手机号">
          {{ nickName }}
        </el-form-item>
        <el-form-item label="充值金额" prop="money">
          <el-input
            v-model.number="addMoneyForm.money"
            placeholder="请输充值金额"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addMoney = false">取消</el-button>
        <el-button type="primary" @click="paying">确定</el-button>
      </div>
    </el-dialog>
    <BatchSetCardDialog :dialog="BatchSetCardDialog" :list="selectList" />
  </div>
</template>

<script>
import maintainAbleCard from "@/maintain/api/user/card-manage/maintainAbleCard";
import maintainBindCardForWeChat from "@/maintain/api/user/card-manage/maintainBindCardForWeChat";
import maintainCancelsCardLossReporting from "@/maintain/api/user/card-manage/maintainCancelsCardLossReporting";
import maintainChangeCard from "@/maintain/api/user/card-manage/maintainChangeCard";
import maintainChargeMoney from "@/maintain/api/user/card-manage/maintainChargeMoney";
import maintainDisableCard from "@/maintain/api/user/card-manage/maintainDisableCard";
import maintainGetAgentCardByPage from "@/maintain/api/user/card-manage/maintainGetAgentCardByPage";
import maintainReportTheLossOfCard from "@/maintain/api/user/card-manage/maintainReportTheLossOfCard";
import maintainUnBind from "@/maintain/api/user/card-manage/maintainUnBind";

import Page from "@/components/Page";
import createdMixin from "@/mixin/createMixin";
import dialogMixin from "@/mixin/dialogMixin";
import formatPhone from "@/mixin/formatPhoneMixin";
import pageMixin from "@/mixin/pageMixin";
import ResDispose from "@/mixin/resDisposeMixin";
import searchMixin from "@/mixin/searchMixin";
import { checkPhone } from "@/utils/check";
import { Message } from "element-ui";
import BatchSetCardDialog from "./diolag/BatchSetCardDialog";

export default {
  components: { BatchSetCardDialog, Page },
  name: "ElectricityCardManageOne",
  mixins: [pageMixin, dialogMixin, searchMixin, createdMixin, ResDispose],
  data: () => {
    return {
      bindDialog: false,
      bindRules: {
        name: [{ required: true, message: "请输入用户名" }],
        phone: checkPhone,
      },
      bindForm: {
        cardId: undefined,
        phone: undefined,
        name: undefined,
      },
      shiftDialog: false,
      shiftRules: {
        newCardNum: [{ required: true, message: "请输入新卡号" }],
      },
      shiftForm: {
        oldCardId: undefined,
        newCardNum: undefined,
      },
      moneyRules: {
        money: [
          { required: true, message: "请输入充值金额", trigger: "change" },
          {
            type: "number",
            message: "充值金额必须为数字值",
            trigger: "change",
          },
        ],
      },
      addMoney: false,
      addMoneyForm: {
        id: undefined,
        userId: undefined,
        money: undefined,
      },
      phone: "",
      nickName: "",
      unbindDialog: false,
      deleteId: undefined,
      paramsDisabled: {
        cardId: undefined,
      },
      paramsAbleCard: {
        cardId: undefined,
      },
      params: {
        state: undefined,
        cardId: undefined,
        number: undefined,
        name: undefined,
        sortName: "id",
        sortType: "DESC",
      },
      records: [],
      BatchSetCardDialog: false,
      selectList: [],
      status: [
        { value: "0", label: "未绑定" },
        { value: "1", label: "已绑定" },
        { value: "-1", label: "已禁用" },
        { value: "-2", label: "已挂失" },
        { value: "-3", label: "已更换" },
      ],
    };
  },
  methods: {
    resetFields() {
      this.params.state = undefined;
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }
      // console.log(this.params.sortName)
      // console.log(this.params.sortType)
      this.fetchData();
    },
    setCardList() {
      if (this.selectList.length === 0) {
        Message({
          message: "请选择电卡!",
          type: "warning",
          duration: 3 * 1000,
        });
      } else {
        this.BatchSetCardDialog = true;
      }
    },
    loss(id) {
      maintainReportTheLossOfCard(id).then((res) => {
        this.resFetch({ res });
      });
    },
    noLoss(id) {
      maintainCancelsCardLossReporting(id).then((res) => {
        this.resFetch({ res });
      });
    },
    fetchData() {
      this.loadTable = true;
      maintainGetAgentCardByPage(this.params, this.current, this.size)
        .then((res) => {
          this.total = res.total;
          this.records = res.records;
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
    bind(id) {
      this.bindForm.cardId = id;
      this.bindDialog = true;
    },
    binding() {
      this.$refs["bindForm"].validate((valid) => {
        if (valid) {
          maintainBindCardForWeChat(this.bindForm).then((res) => {
            this.resDispose({
              res,
              success: () => {
                this.fetchData();
                this.bindDialog = !this.bindDialog;
              },
            });
          });
        }
      });
    },
    handleSelectionChange(val) {
      this.selectList = [];
      for (const key of val) {
        this.selectList.push(key.id);
      }
    },
    shift(id) {
      this.shiftDialog = !this.shiftDialog;
      this.shiftForm.oldCardId = id;
    },
    shifting() {
      this.$refs["shiftForm"].validate((valid) => {
        if (valid) {
          maintainChangeCard(this.shiftForm).then((res) => {
            this.resDispose({
              res,
              success: () => {
                this.fetchData();
                this.shiftDialog = !this.shiftDialog;
              },
            });
          });
        }
      });
    },
    pay(scope) {
      this.addMoneyForm.userId = scope.row.id;
      this.nickName = scope.row.phone;
      this.addMoney = true;
    },
    paying() {
      this.$refs["payForm"].validate((valid) => {
        if (valid) {
          maintainChargeMoney(this.addMoneyForm).then((res) => {
            this.resDispose({
              res,
              success: () => {
                this.fetchData();
                this.addMoney = false;
              },
            });
          });
        }
      });
    },
    activate(id) {
      this.paramsAbleCard.cardId = id;
      maintainAbleCard(this.paramsAbleCard).then((res) => {
        this.resFetch({ res });
      });
    },
    disabled(id) {
      this.paramsDisabled.cardId = id;
      maintainDisableCard(this.paramsDisabled).then((res) => {
        this.resFetch({ res });
      });
    },
    unbind() {
      maintainUnBind(this.deleteId).then((res) => {
        this.resDispose({
          res,
          success: () => {
            this.fetchData();
            this.unbindDialog = !this.unbindDialog;
          },
        });
      });
    },
    skip(cardId, id) {
      this.$router.push({
        name: "电卡详细",
        params: {
          cardId: cardId,
        },
        query: {
          id: id,
        },
      });
    },
  },
  watch: {
    "params.phone": {
      handler() {
        this.params.phone = formatPhone(this.params.phone);
      },
    },
  },
};
</script>
